<template>
	<div id="app">
		<!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/> -->
		<!--	<div class="topbg1"></div>-->

		<div id="wrapper" class=" tleft">
			<!-- wrapper -->
			<div id="out-content" class="pb">
				<!-- out-content -->
				<div class="w1" style="height: 209px;">
					<!-- w1 -->

					<div class="header">
						<!-- header -->
						<div class="L">
							<div class="logo"></div>
							<!-- <div  class="topmenu"> --><!-- topmenu -->
								<!-- <ul>
									<router-link to="/" exact-active-class="on" tag="li">
										<a>首页</a>
									</router-link>
									<router-link to="/tuijian" exact-active-class="on" tag="li">
										<a>推荐</a>
									</router-link>
									<router-link to="/toutiao" exact-active-class="on" tag="li">
										<a>头条</a>
									</router-link>
									<router-link to="/jianbao" active-class="on" tag="li">
										<a>简报</a>
									</router-link>
									<router-link to="/pinglun" active-class="on" tag="li">
										<a>评论</a>
									</router-link>
									<router-link to="/shushuo" exact-active-class="on" tag="li">
										<a>数说</a>
									</router-link>
									<router-link to="/zhuanjia" exact-active-class="on" tag="li">
										<a>专家</a>
									</router-link>
									<router-link to="/gongbao" active-class="on" tag="li">
										<a>公报</a>
									</router-link>
									<router-link to="/zhengce" active-class="on" tag="li">
										<a>政策</a>
									</router-link>
									<router-link to="/guihua" active-class="on" tag="li">
										<a>规划</a>
									</router-link>
								</ul> -->
							<!-- </div> --><!-- /topmenu -->
							<div class="menu menu1 menutopv2">
								<!-- menu -->
								<ul>
									<router-link to="/" exact-active-class="on" tag="li">
										<em><a ><u>首页</u></a><color></color></em>
									</router-link>
									<router-link to="/tuijian" exact-active-class="on" tag="li">
										<em><a ><u>推荐</u></a><color></color></em>
									</router-link>
									<router-link to="/toutiao" exact-active-class="on" tag="li">
										<em><a ><u>头条</u></a><color></color></em>
									</router-link>
									<router-link to="/jianbao" active-class="on" tag="li">
										<em><a ><u>简报</u></a><color></color></em>
									</router-link>
									<router-link to="/pinglun" active-class="on" tag="li">
										<em><a ><u>评论</u></a><color></color></em>
									</router-link>
									<router-link to="/shushuo" exact-active-class="on" tag="li">
										<em><a ><u>数说</u></a><color></color></em>
									</router-link>
									<router-link to="/zhuanjia" exact-active-class="on" tag="li">
										<em><a ><u>专家</u></a><color></color></em>
									</router-link>
									<router-link to="/gongbao" active-class="on" tag="li">
										<em><a ><u>公报</u></a><color></color></em>
									</router-link>
									<!-- <router-link to="/zhengce" active-class="on" tag="li">
										<em><a ><u>政策</u></a><color></color></em>
									</router-link> -->
									<router-link to="/guihua" active-class="on" tag="li">
										<em><a ><u>规划</u></a><color></color></em>
									</router-link>
								</ul>
							</div><!-- /menu -->
						</div>
						<ul class="R">
							<li v-if="$route.name!='search'">
								<div class="search_box  ">
									<input type="text" ref="searchinput" v-model="keyword" @focus="showsug" @keyup="showsug" @blur="hidesug" @keypress.enter="jumpSearch" class="search_input" value="" placeholder="输入搜索内容"
										style="width:7em">
									<button type="button" class="search_btn1" @click="jumpSearch"></button>
									<button v-if="userinfo&&(userinfo.usertype=='99'||isShowAISearch)" type="button" class="search_btn_top_ai" @click="aisearchJump" title="AI搜索"></button>
								</div>
								<div class="Search1" style="margin-bottom: 0px;border: 0;">
									<div class="search_dropdown" v-show="showsugflag" style="top:0px;width: 300px;z-index: 3;color: #424656;border:0px;">
										<!-- search_dropdown -->
										<ul class="hotkeywords">
											<li v-for="(item,index) in sugwordsList" @mousedown="selhistory(item)" style="margin-left: 0px;">
												<btn v-html="item.replace(cachekeyword,'<span style=\'font-weight:bold;\'>'+cachekeyword+'</span>')"></btn>
											</li>
										</ul>
									</div><!-- /search_dropdown -->
								
									<div class="search_dropdown" v-show="showhistroyflag" style="top:5px;left: -380px;width: 1000px;z-index: 3;color: #424656;">
										<!-- search_dropdown -->
										<div class="search-history">
											<!-- search-history -->
											<ul class="title5">
												<li class="L">检索历史</li>
												<li class="R">
													<btn @mousedown.prevent="removehistoryall" class="clearall">清空全部</btn>
												</li>
											</ul>
											<ul class="history-words">
												<li v-for="(item,index) in keyhistory" class="">
													<btn @mousedown.prevent="selhistory(item)">{{item}}</btn><i @mousedown.prevent="removehistory(item)"
														class="cei-icon icon-history-clear"></i>
												</li>
											</ul>
											<ul class="title5">
												<li class="L">检索热词</li>
												<li class="R"></li>
											</ul>
											<ul class="hot-words">
												<li v-for="(item,index) in hotwords" class="" class="">
													<btn @mousedown.prevent="selhistory(item)">{{item}}</btn>
												</li>
											</ul>
								
								
										</div><!-- /search-history -->
									</div><!-- /search_dropdown -->
								</div><!-- /Search1 -->
								
							</li>
							<!-- <li class="top_nav"><a href="javascript:;">专家视点</a></li> -->
							<li class="top_nav">
								<router-link to="/daohang" target="_blank">导航</router-link>
							</li>
							<li class="vline"></li>
							<!-- <li class="top_nav" v-if="!userinfo"><a @click="getuserinfofnc">登录</a></li> -->
							<li class="top_user">
								<template v-if="userinfo">
									<a href="javascript:;">
									<div class="user_head"></div>
									<!-- <div class="user_name">{{userinfo.username}}</div> -->
									<div class="My_menu">
										<ul>
											<li class="menu-accountname" name="accountname"><span style="width: 100%;">{{userinfo.username}}</span></li>
											<li class="menu-myaccount" name="D_account" @click="showzhanghu"><i></i>我的账户</li>
											<li class="menu-mytrack" name="D_track" @click="showzuji"><i></i>我的足迹</li>
											<li class="menu-mysubscribe" name="D_subscribe" @click="showdingyue"><i></i>我的订阅</li>
											<li class="menu-mycollection" name="D_collection" @click="showshoucang"><i></i>我的收藏</li>
											<li class="menu-myCA" name="D_CA" @click="showzixunjianyi"><i></i>咨询与建议</li>
											<li class="menu-exit" @click="logoutfnc"><i></i>退出登录</li>
										</ul>
									</div>
									</a>
								</template>
								<a v-else @click="checkLoginStatus" style="cursor: pointer;">
									<!-- <div class="user_head"></div> -->
									<div class="user_name">登录</div>
								</a>
							</li>
						</ul>
					</div><!-- /header -->


					<div class="menu menu1">
						<!-- menu -->
						<ul>
							<router-link to="/zthongguan" exact-active-class="on" tag="li">
								<em><a ><u>宏观经济</u></a><color></color></em>
							</router-link>
							<router-link to="/ztxiandaijinrong" exact-active-class="on" tag="li">
								<em><a ><u>现代金融</u></a><color></color></em>
							</router-link>
							<router-link to="/ztchanyejingji" exact-active-class="on" tag="li">
								<em><a ><u>产业经济</u></a><color></color></em>
							</router-link>
							<router-link to="/ztquyufazhan" exact-active-class="on" tag="li">
								<em><a ><u>区域发展</u></a><color></color></em>
							</router-link>
							<router-link to="/ztguojijingji" exact-active-class="on" tag="li">
								<em><a ><u>国际经济</u></a><color></color></em>
							</router-link>
							<router-link to="/ztshuzijingji" exact-active-class="on" tag="li">
								<em><a ><u>数字经济</u></a><color></color></em>
							</router-link>
							<router-link to="/ztshuangtan" exact-active-class="on" tag="li">
								<em><a ><u>碳达峰碳中和</u></a><color></color></em>
							</router-link>
							<router-link to="/ztminyingjingji" exact-active-class="on" tag="li">
								<em><a ><u>民间投资</u></a><color></color></em>
							</router-link>
							<router-link to="/ztxiangcunzhenxing" exact-active-class="on" tag="li">
								<em><a ><u>乡村振兴</u></a><color></color></em>
							</router-link>
							<router-link to="/ztxinxingchengzhenhua" exact-active-class="on" tag="li">
								<em><a ><u>新型城镇化</u></a><color></color></em>
							</router-link>
							<router-link v-if="$route.name=='ztchengshigengxin'||zhuantiSubmenuMoreLink=='ztchengshigengxin'" to="/ztchengshigengxin" exact-active-class="on" tag="li">
								<em><a ><u>城市更新</u></a><color></color></em>
							</router-link>
							<router-link v-if="$route.name=='ztlianghui'||zhuantiSubmenuMoreLink=='ztlianghui'" to="/ztlianghui" exact-active-class="on" tag="li">
								<em><a ><u>全国两会</u></a><color></color></em>
							</router-link>
							<router-link v-if="$route.name=='ztgongzuohui'||zhuantiSubmenuMoreLink=='ztgongzuohui'" to="/ztgongzuohui" exact-active-class="on" tag="li">
								<em><a ><u>中央经济工作会</u></a><color></color></em>
							</router-link>
							<router-link v-if="$route.name=='ztjujiao'||zhuantiSubmenuMoreLink=='ztjujiao'" to="/ztjujiao" exact-active-class="on" tag="li">
								<em><a ><u>聚焦二十大</u></a><color></color></em>
							</router-link>
							<li id="MenuMoreSub" class="menu_more" style="margin-left: auto;" @click="showMenuMorePanel()" >
								<img src='/images/menu_more.png' style="vertical-align: unset;" />
								<el-collapse-transition>
									<div class="subMenu " v-show="zhuantiSubmenuVisible" >
										<div class="subMenuDiv">
											<div class="subMenuTitle">常规专题</div>
											<dl >
												<dd>
													<a @click.stop="clickSubMenu('ztchengshigengxin')" >城市更新</a>
												</dd>
											</dl>
										</div>
										<div class="subMenuDiv">
											<div class="subMenuTitle">历史专题</div>
											<dl >
												<dd>
													<a @click.stop="clickSubMenu('ztlianghui')" >全国两会</a>
												</dd>
												<dd>
													<a @click.stop="clickSubMenu('ztgongzuohui')" >中央经济工作会</a>
												</dd>
												<dd>
													<a @click.stop="clickSubMenu('ztjujiao')" >聚焦二十大</a>
												</dd>
											</dl>
										</div>
									</div>
								</el-collapse-transition>
							</li>
						</ul>
						
						<div>
							
						</div>
					</div><!-- /menu -->

				</div><!-- /w1 -->

					<router-view @showLogin="showLogin" @showzixunjianyifromsearch="showzixunjianyifromsearch"/>




				
			</div><!-- /out-content -->
		</div><!-- /wrapper -->


		<appfooter @showshiyong="showshiyong"></appfooter>


		<!-- fixed_floating -->
		<div class='fixed_floating'>
			<div class='fixed_floating-box'>
				<ga>
					<a  class='a a-myaccount '  name='D_account' @click="showzhanghu"><i class='i'></i></a><!--我的账户-->
					<a  class='a a-mytrack '  name='D_track' @click="showzuji"><i class='i'></i></a><!--我的足迹-->
					<a  class='a a-mysubscribe '  name='D_subscribe' @click="showdingyue"><i class='i'></i></a><!--我的订阅-->
					<a  class='a a-mycollection '  name='D_collection' @click="showshoucang"><i class='i'></i></a><!--我的收藏-->
					<a  class='a a-myCA'  name='D_CA' @click="showzixunjianyi"><i class='i'></i></a><!--咨询与建议-->
					<a  class='a a-QRcode '><i class='i'></i></a><!--二维码-->
				</ga>
				<gb><a href='javascript:;' class='a  a-top'><i class='i'></i></a></gb><!--返回顶部-->
				<div class='d d-myaccount'>
					<i class='arrow'></i>
					<div class='inner-box'>
						<div class='d-item '>
							我的账户
						</div>
					</div>
				</div>
				<div class='d d-mytrack'>
					<i class='arrow'></i>
					<div class='inner-box'>
						<div class='d-item '>
							我的足迹
						</div>
					</div>
				</div>
				<div class='d d-mysubscribe'>
					<i class='arrow'></i>
					<div class='inner-box'>
						<div class='d-item '>
							我的订阅
						</div>
					</div>
				</div>
				<div class='d d-mycollection'>
					<i class='arrow'></i>
					<div class='inner-box'>
						<div class='d-item '>
							我的收藏
						</div>
					</div>
				</div>
				<div class='d d-myCA'>
					<i class='arrow'></i>
					<div class='inner-box'>
						<div class='d-item '>
							咨询与建议
						</div>
					</div>
				</div>
				<div class='d d-QRcode'>
					<i class='arrow'></i>
					<div class='QRcode-box'>
						<img src='/images/ma_gzh.jpg' width='88' height='88' alt=''>
						<div style="text-align: center;font-size: 14px;">公众号</div>
						<img src='/images/ma_xcx.jpg' width='88' height='88' alt=''>
						<div style="text-align: center;font-size: 14px;">小程序</div>
					</div>
				</div>
				<div class='d d-top'>
					<i class='arrow'></i>
					<div class='inner-box'>
						<div class='d-item '>
							返回顶部
						</div>
					</div>
				</div>
		
			</div>
		</div>
		<!-- /fixed_floating -->
		
		<div class='fixed_floating2' v-show="limitAdBannerVisible">
			<div class='fixed_floating2-box'>
					<a  class='a a-myaccount '  name='D_account' href="/activity" target="_blank"><img src="/images/downloadad.png"></a>
					<a @click="limitAdBannerVisible=false" style="width: 100%;display: inline-block;text-align: center;font-size: 13px;">X关闭</a>
			</div>
		</div>
		<div class='fixed_floating2' v-show="adBannerVisible">
			<div class='fixed_floating2-box'>
				  <!-- <img @click="adBannerVisible=false" src="/images/icon_close.png" style="position: absolute;right: 0px;top: 0px;"> -->
					<!-- <a  class='a a-myaccount '  name='D_account' @click="showDownloadDialog"><img src="/images/downloadad.png"></a> -->
					<a  class='a a-myaccount '  style="height: 290px;"  name='D_account' href="https://mp.weixin.qq.com/s/xpFhI5-kv6Q0nHptob5W7Q" target="_blank"><img src="/images/downloadad-bak.png" style="height: 290px;"></a>
					<a @click="adBannerVisible=false" style="width: 100%;display: inline-block;text-align: center;font-size: 13px;">X关闭</a>
			</div>
		</div>
		
		<!-- <el-dialog title="资料需求" :visible.sync="zlxqVisible">
		  <el-form :model="form">
		    <el-form-item label="所需资料的详细描述">
		      <el-input type="textarea" v-model="form.desc"></el-input>
		    </el-form-item>
		    <el-form-item label="邮箱">
		      <el-input v-model="form.email"></el-input>
		    </el-form-item>
				<el-form-item label="联系电话">
				  <el-input v-model="form.phone"></el-input>
				</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="zlxqVisible = false">取 消</el-button>
		    <el-button type="primary" @click="addzlxq">确 定</el-button>
		  </div>
		</el-dialog> -->
		
		<floatzhanghu ref="zhanghuhandle" v-if="zhanghuVisible" v-bind:userinfo="userinfo" @closefloat="closezhanghu"
		 @showbangding="showbangding" @showquxiao="showquxiao" @showyanqi="showyanqi" v-bind:isdetailopen="bangdingVisible||quxiaoVisible||yanqiVisible"></floatzhanghu>
		 <floatbangding v-if="bangdingVisible" v-bind:userinfo="userinfo" @closefloat="closebangding"></floatbangding>
		 <floatquxiao v-if="quxiaoVisible" v-bind:userinfo="userinfo" @closefloat="closequxiao"></floatquxiao>
		 <floatyanqi v-if="yanqiVisible" v-bind:userinfo="userinfo" @closefloat="closeyanqi"></floatyanqi>
		<floatzuji v-if="zujiVisible" v-bind:userinfo="userinfo" @closefloat="closezuji"></floatzuji>
		<floatdingyue v-if="dingyueVisible" v-bind:userinfo="userinfo" @closefloat="closedingyue"></floatdingyue>
		<floatshoucang v-if="shoucangVisible" v-bind:userinfo="userinfo" @closefloat="closeshoucang"></floatshoucang>
		<floatzixunjianyi ref="zxjyhandle" v-if="zixunjianyiVisible" v-bind:userinfo="userinfo" @closefloat="closezixunjianyi"
		 @showzixun="showzixun" @showjianyi="showjianyi" v-bind:isdetailopen="zixunVisible||jianyiVisible" v-bind:showcolum="zixunjianyiColum"></floatzixunjianyi>
		<floatzixun v-if="zixunVisible" v-bind:detailid="zixunid" @closefloat="closezixun"></floatzixun>
		<floatjianyi v-if="jianyiVisible" v-bind:detailid="jianyiid" @closefloat="closejianyi"></floatjianyi>
		<floatshiyong v-if="shiyongVisible" @closefloat="closeshiyong"></floatshiyong>
		
		
		
		<keep-alive>
			<floatlogin v-if="dialogLoginVisible"  @closefloat="closelogin"></floatlogin>
		</keep-alive>
		
		<el-dialog class="dialogAD" :visible.sync="dialogADVisible" :close-on-click-modal="true" :close-on-press-escape="false" width="1107px" >
		  <floatad></floatad>
		</el-dialog>
		
		<!-- <el-dialog :visible.sync="dialogDownloadVisible" title="中央经济工作会专刊领取 (持续更新)" :close-on-click-modal="true" :close-on-press-escape="false" width="800px" center>
		  <floatdownload @closefloat="closedownload"></floatdownload>
		</el-dialog> -->
		
		<iframe :src="exiturl" style="height:0px;display:none;" height="0"></iframe>
		
	</div>
</template>

<script>
	//网站主页大框架，包含了网站的菜单等通用框架
	import appfooter from '@/components/footer.vue'
	import floatzhanghu from '@/components/float-zhanghu.vue'
	import floatzuji from '@/components/float-zuji.vue'
	import floatdingyue from '@/components/float-dingyue.vue'
	import floatshoucang from '@/components/float-shoucang.vue'
	import floatzixunjianyi from '@/components/float-zixunjianyi.vue'
	import floatzixun from '@/components/float-zixunjianyi-zixun.vue'
	import floatjianyi from '@/components/float-zixunjianyi-jianyi.vue'
	import floatshiyong from '@/components/float-shiyong.vue'
	import floatlogin from '@/components/home-login2.vue'
	import floatad from '@/components/home-ad.vue'
	import floatdownload from '@/components/home-download2.vue'
	import floatbangding from '@/components/float-zhanghu-bangding.vue'
	import floatquxiao from '@/components/float-zhanghu-quxiao.vue'
	import floatyanqi from '@/components/float-zhanghu-yanqi.vue'
	export default {
		data() {
			return{
				dialogADVisible:false,
				dialogDownloadVisible:false,
				dialogLoginVisible:false,
				userinfo:'',
				exiturl:'',
				keyword:'',
				zhanghuVisible:false,
				zujiVisible:false,
				dingyueVisible:false,
				shoucangVisible:false,
				zixunjianyiVisible:false,
				zixunjianyiColum:'zixun',
				zixunVisible:false,
				zixunid:'',
				jianyiVisible:false,
				jianyiid:'',
				shiyongVisible:false,
				bangdingVisible:false,
				quxiaoVisible:false,
				yanqiVisible:false,
				
				showsugflag: false,
				sugdelaytimer:'',
				sugstaytimer:'',
				sugwordsList:[],
				showhistroyflag: false,
				keyhistory: [],
				hotwords: [],
				cachekeyword: '',
				
				zhuantiSubmenuMoreLink:'',
				zhuantiSubmenuVisible:false,
				zhuantiSubmenuListener:'',
				
				adBannerVisible:false,
				limitAdBannerVisible:false,
				
				isShowAISearch:false,
			}
		},
		components:{
			appfooter,
			floatzhanghu,
			floatzuji,
			floatdingyue,
			floatshoucang,
			floatzixunjianyi,
			floatzixun,
			floatjianyi,
			floatshiyong,
			floatlogin,
			floatad,
			floatdownload,
			floatbangding,
			floatquxiao,
			floatyanqi
		},
		created:function(){
			this.getusernamefnc();
			// this.getuserauthfnc();
		},
		mounted:function(){
			this.checkIsNeedADBanner();
			this.checkIsNeedADDialog();
			this.checkIsNeedLoginDialog();
			// console.log(this.$route.name);
			this.loadLinkSelect();
			this.getAIShowfnc();
		},
		methods: {
			//打开关闭首页主菜单里的更多专题面板
			showMenuMorePanel:function(){
				let _this = this;
				if(this.zhuantiSubmenuVisible==true){
					this.zhuantiSubmenuVisible=false;
					document.removeEventListener('click',_this.zhuantiSubmenuListener);
				}
				else{
					this.zhuantiSubmenuVisible=true;
					_this.zhuantiSubmenuListener=function(e){
						if(!document.getElementById('MenuMoreSub').contains(e.target)){
							_this.zhuantiSubmenuVisible=false;
							document.removeEventListener('click',_this.zhuantiSubmenuListener);
						}
					}
					document.addEventListener('click',_this.zhuantiSubmenuListener)
				}
			},
			//切换菜单栏上显示的专题
			clickSubMenu:function(linkname){
				this.$router.push({name:linkname});
				this.$cookies.set('morelinkname',linkname);
				this.zhuantiSubmenuMoreLink=linkname;
				this.zhuantiSubmenuVisible=false;
			},
			//初始化加载更多专题数据
			loadLinkSelect:function(){
				var morelinkarr=['ztlianghui','ztgongzuohui','ztjujiao'];
				if(this.$route.name=='detail'&&this.$route.query.col&&morelinkarr.indexOf(this.$route.query.col)>-1){
					this.zhuantiSubmenuMoreLink=this.$route.query.col;
				}
				else{
					this.zhuantiSubmenuMoreLink=this.$cookies.get('morelinkname')?this.$cookies.get('morelinkname'):'';
				}
			},
			//打开侧边栏下载窗口
			showDownloadDialog:function(){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					this.dialogDownloadVisible=true;
					this.$track([
						['pagetype','推广窗口']
					]);
				}
			},
			//关闭侧边栏下载窗口
			closedownload:function(){
				this.dialogDownloadVisible=false;
			},
			//判断是否需要展示限时侧边栏推广广告，不需要则展示常规侧边栏推广
			checkIsNeedADBanner:function(){
				//这里设置推广结束时间
				if(new Date<new Date('2024/05/23 17:30:00')){
					this.adBannerVisible=false;
					this.limitAdBannerVisible=true;
				}
				else{
					this.adBannerVisible=true;
					this.limitAdBannerVisible=false;
				}
			},
			//判断是否需要展示限时开屏弹窗展示，推广12个小时展示一次
			checkIsNeedADDialog:function(){
				//这是设置开屏弹框推广结束时间
				if((!this.$cookies.get('adshowed'))&&(new Date<new Date('2024/05/23 17:30:00'))){
					this.dialogADVisible=true;
					this.$cookies.set('adshowed','1','12h');
				}
			},
			checkIsNeedLoginDialog:function(){
				if(this.$cookies.get('unlogin')){
					this.showLogin()
					this.$cookies.remove('unlogin');
				}
			},
			getusernamefnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'getUserName',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						if(response.data&&response.data.data.data){
							_this.userinfo=response.data.data.data;
							_this.$cookies.set('userinfo',_this.userinfo);
							if(_this.$cookies.get('fromdetail')){
								var detailhref=_this.$cookies.get('fromdetail');
								_this.$cookies.remove('fromdetail');
								window.location.href=detailhref;
							}
							// _this.getuserauthfnc();
						}
						else{
							_this.$cookies.remove('userinfo');
							_this.userinfo='';
							_this.$cookies.remove('userauth');
						}
						
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getuserinfofnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/getUserInfo',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						// debugger;
						var tempinfo={
							userAccountID:response.data.data.data.userAccountID,
							username:response.data.data.data.username,
							usertype:response.data.data.data.usertype,
							outUrl:response.data.data.data.outUrl
						}
						_this.userinfo=tempinfo;
						_this.$cookies.set('userinfo',tempinfo);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getuserauthfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/getLstAuthInfo',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						if(response.data.code==20001){
							_this.$cookies.set('userauth','1921f9e1416473a1d0f15d328e837115');
						}
						else{
							_this.$cookies.set('userauth',response.data.data.data);
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getAIShowfnc: function() {
				let _this = this;
				this.$httpai({
						method: 'get',
						url: 'authvipuser',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						// debugger
						if(response.data.isvip){
							
							_this.isShowAISearch = true;
							
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			checkLoginStatus:function(){
				let _this = this;
				this.$http({
						method: 'get',
						url: 'getUserName',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						if(response.data&&response.data.data.data){
							_this.userinfo=response.data.data.data;
							_this.$cookies.set('userinfo',_this.userinfo);
						}
						else{
							_this.$cookies.remove('userinfo');
							_this.userinfo='';
							_this.showLogin();
						}
						
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showLogin:function(){
				this.dialogLoginVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closelogin:function(){
				this.dialogLoginVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showsug: function() {
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				if (this.keyword) {
					if(this.cachekeyword!=this.keyword){
						this.getsugfnc();
					}
					this.showsugflag = true;
					this.showhistroyflag = false;
				} else {
					this.keyhistory = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
					this.cachekeyword='';
					this.showsugflag = false;
					this.showhistroyflag = true;
					this.gethotwordfnc();
				}
			},
			hidesug: function() {
				this.showsugflag = false;
				this.showhistroyflag = false;
			},
			removehistory: function(key) {
				var temphistorylist = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
				if (temphistorylist.indexOf(key) > -1) {
					temphistorylist.splice(temphistorylist.indexOf(key), 1);
					this.keyhistory = temphistorylist;
					this.$cookies.set('keyhistory', temphistorylist.toString(),'30d');
				}
			},
			removehistoryall: function() {
				this.keyhistory = '';
				this.$cookies.remove('keyhistory');
			},
			selhistory: function(key) {
				this.keyword = key;
				this.jumpSearch();
			},
			getsugfnc: function() {
				if (this.keyword) {
					let _this = this;
					this.cachekeyword=this.keyword;
					this.$http({
							method: 'get',
							url: 'SearchInfo/SugHotWordListInfo',
							responseType: 'json',
							params: {
								sugKey: this.keyword,
							},
						})
						.then(function(response) {
							_this.sugwordsList = response.data.data.data;
							clearTimeout(_this.sugstaytimer);
							_this.sugstaytimer = setTimeout(function (){
								if(_this.showsugflag&&_this.sugwordsList.length>0){
									_this.$track([
										['pagetype','sug提示'],
										['searchkeyword',_this.sugwordsList.join(' ')]
									]);
								}
							}, 2000);
							if(_this.sugwordsList.length<1){
								_this.showsugflag = false;
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			gethotwordfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'SearchInfo/SearchWordsListInfo',
						responseType: 'json',
						params: {
						},
					})
					.then(function(response) {
						_this.hotwords = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			aisearchJump:function(){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				if (this.keyword) {
					this.$refs.searchinput.blur();
					this.hidesug();
					let to = window.SITE_CONFIG['aiSearchUrl']+encodeURIComponent(this.keyword);
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			jumpSearch: function() {
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				// this.$router.push('/search'+(this.keyword?('/'+this.keyword):''));
				// window.open('/search'+(this.keyword?('/'+this.keyword):''), '_blank');
				this.$refs.searchinput.blur();
				this.hidesug();
				var a = document.createElement('a');
				a.setAttribute('href', '/search'+(this.keyword?('/'+encodeURIComponent(this.keyword)):''));
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a);  
				this.keyword='';
			},
			logoutfnc:function(){
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/out',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						debugger
						if(response.data.code==20000){
							var tempoutUrl=_this.$cookies.get('userinfo').outUrl;
							_this.$cookies.remove('userinfo');
							_this.$cookies.remove('autologintoken');
							_this.exiturl=tempoutUrl;
							// _this.$alert('已退出登录', '提示信息', {
							// 	confirmButtonText: '确定',
							// 	callback: function(action) {
							// 		window.location.href='/';
							// 	}
							// });
							
							// var iframe1 = document.getElementById('exit');
							// if (-1 == navigator.userAgent.indexOf("MSIE")) {
							// 		iframe1.src = tempoutUrl;
							// } else {
							// 		iframe1.location = tempoutUrl;
							// }
							
							// window.location.href=tempoutUrl;
							//统一认证退出链接,appid为新专网id
							// window.location.href='https://passport.cei.cn/Action/DoView.ashx?view=exit&appid=10011018';
						}
						else{
							_this.$message({
								message: '退出失败，请重试',
								type: 'warning'
							});
						}
						
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showzhanghu:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.zhanghuVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closezhanghu:function(){
				this.getusernamefnc();
				this.zhanghuVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showzuji:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.zujiVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closezuji:function(){
				this.zujiVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showdingyue:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.dingyueVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closedingyue:function(){
				this.dingyueVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showshoucang:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.shoucangVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closeshoucang:function(){
				this.shoucangVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showzixunjianyi:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.zixunjianyiVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closezixunjianyi:function(){
				this.zixunjianyiVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showzixunjianyifromsearch:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.zixunjianyiColum='jianyi';
				this.zixunjianyiVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			showzixun:function(id){
				this.zixunid=id;
				this.zixunVisible=true;
			},
			closezixun:function(){
				this.zixunVisible=false;
				this.$refs.zxjyhandle.getZixunListfnc();
			},
			showjianyi:function(id){
				this.jianyiid=id;
				this.jianyiVisible=true;
			},
			closejianyi:function(){
				this.jianyiVisible=false;
				this.$refs.zxjyhandle.getFankuiListfnc();
			},
			showshiyong:function(){
				// if(this.userinfo){
				// 	this.$message({
				// 		message: '该功能仅提供给非注册用户，您已登录，请继续使用',
				// 		type: 'warning'
				// 	});
					
				// 	return false;
				// }
				this.shiyongVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closeshiyong:function(){
				this.shiyongVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showbangding:function(){
				this.bangdingVisible=true;
			},
			closebangding:function(){
				this.bangdingVisible=false;
				this.$refs.zhanghuhandle.getuserinfofnc();
			},
			showquxiao:function(){
				this.quxiaoVisible=true;
			},
			closequxiao:function(){
				this.quxiaoVisible=false;
				this.$refs.zhanghuhandle.getuserinfofnc();
			},
			showyanqi:function(){
				this.yanqiVisible=true;
			},
			closeyanqi:function(){
				this.yanqiVisible=false;
				this.$refs.zhanghuhandle.getuserinfofnc();
			},
		}
	}
</script>

<style>
	.menu ul {
		min-height: 50px;
	}
	/* .w1{
		min-height: 1000px;
	} */
	/* .fixed_floating .d-02{top:0px;}
	.fixed_floating .d-03{top:40px;}
	.fixed_floating .d-04{top:80px;}
	.fixed_floating .d-05{top:120px;}
	.fixed_floating .d-top{top:172px;} */
</style>
